module.exports = __webpack_public_path__ + "static/media/serious_600.989b297a.jpg";